(() => {
  const codeBtn = document.querySelectorAll(".js-banner-code");

  codeBtn.forEach((btn) => {
    btn.addEventListener("click", async () => {
      const code = btn.getAttribute("data-discount-code");
      btn.classList.add("isActive");
      await navigator.clipboard.writeText(code);
      setTimeout(() => {
        btn.classList.remove("isActive");
      }, 500);
    });
  });
})();
